import { SbsaFeatures } from '../interface/features.interface';

export const features: SbsaFeatures = {
    favouriteBeneficiary: true,
    isUsernameMigrationActive: true,
    fraudRiskToggle: true,
    beneficiaryGroups: true,
    sbsaInstantPayments: true,
    isSchedulePaymentEnabled: true,
    canScheduleOnPayMultiple: false,
    saveBeneficiary: true,
    accountResolution: true,
    customerProfile: true,
    deleteMultipleBeneficiaries: false,
    helpCentre: true,
    printDownloadPaymentReceipt: true,
    editEapLimitsOnCard: true,
    increaseLimitAmountValidationPopup: true,
    coachMarksDashboard: true,
    coachMarksCardDetails: false,
    coachMarksPayments: false,
    coachMarksBeneficiaries: false,
    coachMarksBeneficiaryGroups: false,
    customerSurvey: false,
    scheduledPaymentNotifications: false,
    scheduledPaymentPrintOrDownload: true,
    scheduledPaymentAmount: true,
    scheduledPaymentsNps: true,
    onboardingScreens: true,
    myBills: true,
    postLoginContactUs: true,
    relevantDashboardManagement: true,
    npsDialog: true,
    buyAirtime: true,
    cardSettingsUseYourCardAtAtms: true,
    cardSettingsMakeOnlinePurchases: true,
    cardSettingsSwitchCardOnOrOff: true,
    cardSettingsAllowTapAndGo: true,
    cardSettingsEnableWearablesAndWallets: true,
    cardSettingsPosAllowed: true,
    payMultipleSavedBeneficiaries: true,
    preferredDashboard: true,
    linkAndConfirmProfile: true,
    buyElectricity: true,
    emailTransactions: true,
    preloginContactUs: true,
    transferHistory: true,
    proofOfPaymentHistory: true,
    paymentNotificationsHistory: true,
    cardSettings: true,
    cardSettingsTravelAbroad: true,
    prepaidHistory: true,
    payInIntPmts: true,
    payOutIntPmts: true,
    buyFn: true,
    sellFn: true,
    outwardsRemittance: true,
    productHubMfeEntryPoint: true,
    cardLimits: true,
    beneficiaryMaximum: true,
    vafTileMfe: true,
    closedAccountDocuments: true,
    uCountRewardsMfe: true,
    my360Mfe: true,
    vafMfe: true,
    onlineShareTradingMfe: true,
    shyftMfe: true,
    printDownloadPaymentHistoryList: true,
    printDownloadPrepaidHistoryList: false,
    printDownloadSelectedPrepaidHistory: false,
    printDownloadIATList: true,
    interAccountTransferPrintOrDownload: true,
    payBeneficiaryGroups: true,
    printManageVouchersList: true,
    overdraft: true,
    borrow: true,
    manageDebitOrders: true,
    reverseDebitOrder: true,
    stopDebitOrder: true,
    viewDebicheck: true,
    switchDebitOrders: true,
    trackDebitOrderSwitch: true,
    lotto: false,
    accountDetails: true,
    earlyWithdrawal: true,
    viewNotices: true,
    giveNotice: true,
    partialWithdrawal: true,
    linkAccount: true,
    addAccountWithoutCardStandalone: false,
    addDashboard: true,
    maxSelectedBeneficiariesLimit: false,
    trafficFines: true,
    payTrafficFines: true,
    searchTrafficFines: false,
    scheduledRecurringTopup: true,
    createScheduledRecurringTopup: true,
    editScheduledRecurringTopup: true,
    createElectricityRecurringTopup: false,
    editElectricityRecurringTopup: false,
    trafficFinesPaymentNotificationForm: false,
    trafficFinesPrintDownloadPOPButtons: false,
    payMultiplePrintOrDownload: true,
    scheduleMultiGroupPrintOrDownload: true,
    apply: true,
    editAccountView: true,
    activateOtp: true,
    amlReview: true,
    backToIBR: true,
    editPaymentNotificationOnPayMultiple: true,
    useGenerateProofOfPaymentService: true,
    useGenerateInterAccountTransferService: true,
    useGeneratePrepaidHistoryService: true,
    homeServicesTileMfe: true,
    usePaymentHistoryV2Service: true,
    tpsAccountOrigination: true,
    addHomeLoansNonCardLinkedAccounts: true,
    isManageAccountOverflowActionActive: false,
    payShap: false,
    manageSection: true,
    elasticRumMonitoring: false,
    SbsaBalanceMaskingSync: true,
    skipBeneficiarySelection: true,
    standaloneCardSettings: true,
    profilesAndSettingsV2: true,
    addSerialNumberToGetStatements: true,
    creditScore: true
};
